import { useNavigate } from "react-router-dom";
import "./SingleFundraiser.css";
import { FundraiserType } from "../../../Interfaces/FundraiserRole";

type SingleFundraiserComponentProps = {
  campaignName: string;
  goalAmount: number;
  raisedAmount: number;
  fundraiserType: FundraiserType;
  linkExtension: string;
};

const SingleFundraiserComponent: React.FC<SingleFundraiserComponentProps> = ({
  campaignName,
  goalAmount,
  raisedAmount,
  fundraiserType,
  linkExtension,
}) => {
  const progressPercentage = Math.min((raisedAmount / goalAmount) * 100, 100);
  const navigate = useNavigate();

  const handleFundraiserClick = () => {
    if (fundraiserType === "participant") {
      // Navigate to the team admin page
      navigate(`/dashboard/participant/${linkExtension}`);
    } else if (fundraiserType === "rep") {
      // Navigate to the rep page
      navigate(`/dashboard/fundraising-rep/${linkExtension}`);
    } else if (fundraiserType === "coord") {
      //navigate to the coord page
      navigate(`/dashboard/coord/${linkExtension}`);
    }
    // nagivate to the team admin page
    else {
      navigate(`/dashboard/teamAdmin/${linkExtension}`);
    }
  };

  return (
    <div
      onClick={handleFundraiserClick}
      className="user-profile-single-fundraiser-container"
    >
      <h3 className="user-profile-single-fundraiser-title">{campaignName}</h3>
      <div className="user-profile-single-fundraiser-progress-bar">
        <div
          className="user-profile-single-fundraiser-progress"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      <p className="user-profile-single-fundraiser-goal">
        Fundraising Goal: ${goalAmount.toLocaleString()}
      </p>
      <p className="user-profile-single-fundraiser-raised">
        Amount Raised: ${raisedAmount.toLocaleString()}
      </p>
    </div>
  );
};

export default SingleFundraiserComponent;
